module.exports = __webpack_public_path__ + "img/12_49.4878b2ba.png";